import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-text-dialog',
  templateUrl: './text-dialog.component.html',
  styleUrls: ['./text-dialog.component.scss']
})
export class TextDialogComponent implements OnInit {

  public title: string;
  public message: string;
  public positiveText: string;
  public negativeText: string;
  public showNegativeButton: boolean = true;

  constructor(public dialogRef: MdDialogRef<TextDialogComponent>) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/text-dialog/text-dialog.component.ts